import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing, font }) => ({
  toastContainer: {
    maxWidth: spacing(200),
  },
  toastContent: {
    alignItems: "center" as const,
  },
  toast: {
    paddingVertical: spacing(2),
    paddingHorizontal: spacing(3),
  },
  titleStyle: {
    fontFamily: font.families.body,
    fontSize: font.sizes.body,
    lineHeight: font.lineHeights.body,
  },
}));

export default stylesheet;
